import React, {useRef} from 'react';
import { ConfirmContent } from './confirm-content';
import useOutsideAlerter from "../../../../hooks/use-outside-alerter";

// interface Props {
//   path?: string;
//   stroke?: string;
//   width: number;
//   height: number;
//   strokeWidth?: number;
//   positionTop: number;
//   positionLeft: number;
//   dimmerActive: boolean;
//   cancelDelete: () => void;
//   deleteDrawing: () => void;
//   onClick: () => void;
//   svgRef: RefObject<SVGSVGElement>;
//   handleMouseDown: DragEventListener<HTMLDivElement>;
//   handleMouseUp: DragEventListener<HTMLDivElement>;
//   handleMouseMove: DragEventListener<HTMLDivElement>;
//   handleMouseOut: DragEventListener<HTMLDivElement>;
// }
export const DrawingInput = ({
  dimmerActive,
  cancelDelete,
  deleteDrawing,
  positionTop,
  positionLeft,
  width,
  height,
  svgRef,
  path,
  stroke,
  strokeWidth,
  handleMouseDown,
  handleMouseMove,
  handleMouseOut,
  handleMouseUp,
  onClick,
}) => {
  const wrapperRef = useRef(null)
  useOutsideAlerter(wrapperRef,cancelDelete)
  return (
    <div
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseOut={handleMouseOut}
      onDoubleClick={onClick}
      style={{
        position: 'absolute',
        top: positionTop,
        left: positionLeft,
        width,
        height,
        cursor: 'move',
      }}
    >
      {dimmerActive && <div className={"relative"}>
        <svg ref={svgRef}>
          <path
              strokeWidth={strokeWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke={stroke}
              fill="none"
              d={path}
          />
        </svg>
        <div ref={wrapperRef}>
          <ConfirmContent
              title="Delete?"
              onConfirm={deleteDrawing}
              onDismiss={cancelDelete}
          />
        </div>
      </div>}
    </div>
  );
};
